import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";
import { Image } from "@coworker/apprestructured/src/tasks/types/imageUpload";

type Data = {
  creator_id: string;
  text: string;
};

interface CreateNoteProps {
  data: Data;
  images: Image[];
}

export async function createNote(taskId: string, note: Data, images: Image[]) {
  return await httpClient.tasks.post(`/v1/task/${taskId}/create_note`, {
    body: { note, images },
  });
}

export const useCreateNote = (taskId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (note: CreateNoteProps) =>
      createNote(taskId, note.data, note.images),
    onSuccess: async (data: any) => {
      const hasNoteImages = data?.hasImages;
      if (hasNoteImages) {
        await queryClient.invalidateQueries({
          queryKey: ["task", "notes", "images", data?.taskId],
        });
      }
      await queryClient.invalidateQueries({
        queryKey: ["task", "notes", data?.taskId],
      });
    },
  });
};
